export default "__VITE_ASSET__lUZacPyx__"